export default function timeDate(stgDate:Date) {

  const dt = new Date(stgDate);
  const dd = dt.getDate();
  const mm = dt.getMonth() + 1;
  const yyyy = dt.getFullYear();

  const date = stgDate ? new Date(yyyy, mm, dd) : '';
  return date;
}
